import { action, extendObservable } from 'mobx';
import { orderBy } from 'lodash';
import FetchService from '../../../core/services/FetchService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import NotificationService from '../../../core/services/NotificationService';

class PlacementTestItemListService {
  fetch = new FetchService();
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      items: [],
      placementTestId: null,
    });
  }

  init = action((placementTestId) => {
    this.items = [];
    this.placementTestId = placementTestId;
    this.load();
  });

  load = action(() => {
    this.fetch
      .fetch({
        url: `/grammar-placement-test-levels/${this.placementTestId}/items`,
      })
      .then(() => {
        if (this.fetch.data) {
          this.items = orderBy(this.fetch.data, ['order'], ['asc']);
        } else {
          this.items = [];
        }
      });
  });

  handlePublish = action((placementItem) => {
    ConfirmationDialogService.show(
      'Publish Draft Item',
      `Do you really want to publish the draft item with data "Text: ${placementItem.item.text}"?`,
      () => {
        this.submit
          .fetch({
            method: 'patch',
            url: `/grammar-placement-test-levels/${this.placementTestId}/items/${placementItem.item.id}/publish`,
          })
          .then(() => {
            if (this.submit.data) {
              this.load();
            }
            if (this.submit.error) {
              NotificationService.addNotification(this.submit.error || `Error to publish draft item`, 'error');
            }
          });
      }
    );
  });

  handleUnpublish = action((placementItem) => {
    ConfirmationDialogService.show(
      'Unpublish Item',
      `Do you really want to unpublish the item with data "Text: ${placementItem.item.text}"?`,
      () => {
        this.submit
          .fetch({
            method: 'patch',
            url: `/grammar-placement-test-levels/${this.placementTestId}/items/${placementItem.item.id}/unpublish`,
          })
          .then(() => {
            if (this.submit.data) {
              this.load();
            }
            if (this.submit.error) {
              NotificationService.addNotification(this.submit.error || `Error to publish draft item`, 'error');
            }
          });
      }
    );
  });

  handleRemove = action((placementItem) => {
    ConfirmationDialogService.show(
      'Delete Item',
      `Do you really want to unpublish the item with data "Text: ${placementItem.item.text}"?`,
      () => {
        this.fetch
          .fetch({
            method: 'delete',
            url: `/grammar-placement-test-levels/${this.placementTestId}/items/${placementItem.item.id}`,
          })
          .then(() => {
            if (this.submit.data) {
              this.load();
            }
            if (this.submit.error) {
              NotificationService.addNotification(this.submit.error || `Error to delete draft item`, 'error');
            }
          });
      }
    );
  });
}

const placementTestItemListService = new PlacementTestItemListService();

export default placementTestItemListService;
